export default "assets/images/icons/quote-cf95c1e8.svg";